import React, { useState, useEffect } from "react";
import "../styles/PinnedMessagesBar.css";

function getPinnedByLabel(item, currentUserId) {
  if (!item) return "Pinned";
  if (String(item.pinnedBy) === String(currentUserId)) {
    return "You pinned";
  }
  const name = item.pinnedByName || "Someone";
  return `${name} pinned`;
}

const PinnedMessagesBar = ({
  pinnedMessages = [],
  currentUserId,
  onSelect,
  onUnpin,
  canUnpinPin,
}) => {
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (!pinnedMessages.length) {
      setExpanded(false);
    }
  }, [pinnedMessages.length]);

  if (!pinnedMessages.length) return null;

  const latest = pinnedMessages[0];
  const count = pinnedMessages.length;
  const canUnpinItem = (item) =>
    typeof canUnpinPin === "function" ? Boolean(canUnpinPin(item)) : false;

  const handleSelect = (item, event) => {
    if (event) event.stopPropagation();
    if (onSelect && item?.messageId) {
      onSelect(item.messageId);
      setExpanded(false);
    }
  };

  const handleUnpin = (item, event) => {
    event.stopPropagation();
    if (onUnpin && item?.messageId && canUnpinItem(item)) {
      onUnpin(item.messageId);
    }
  };

  return (
    <div className="pinned-messages-bar" role="region" aria-label="Pinned messages">
      <button
        type="button"
        className="pinned-messages-bar-main"
        onClick={() => (count > 1 ? setExpanded((open) => !open) : handleSelect(latest))}
        title={count > 1 ? "Show all pinned messages" : "Jump to pinned message"}
      >
        <span className="pinned-messages-bar-icon" aria-hidden="true">
          📌
        </span>
        <span className="pinned-messages-bar-copy">
          <span className="pinned-messages-bar-title">
            {getPinnedByLabel(latest, currentUserId)}
            {count > 1 ? ` (${count})` : ""}
          </span>
          <span className="pinned-messages-bar-preview">
            {latest.preview || latest.text || "Pinned message"}
          </span>
        </span>
        {count > 1 && (
          <span className={`pinned-messages-bar-chevron${expanded ? " open" : ""}`} aria-hidden="true">
            ▾
          </span>
        )}
      </button>

      {canUnpinItem(latest) && count === 1 && (
        <button
          type="button"
          className="pinned-messages-bar-unpin"
          onClick={(event) => handleUnpin(latest, event)}
          title="Unpin message"
          aria-label="Unpin message"
        >
          ✕
        </button>
      )}

      {expanded && count > 1 && (
        <div className="pinned-messages-list">
          {pinnedMessages.map((item) => (
            <div key={item._id || item.messageId} className="pinned-messages-list-item">
              <button
                type="button"
                className="pinned-messages-list-select"
                onClick={(event) => handleSelect(item, event)}
              >
                <span className="pinned-messages-bar-title">
                  {getPinnedByLabel(item, currentUserId)}
                </span>
                <span className="pinned-messages-list-preview">
                  {item.preview || item.text || "Pinned message"}
                </span>
              </button>
              {canUnpinItem(item) && (
                <button
                  type="button"
                  className="pinned-messages-bar-unpin"
                  onClick={(event) => handleUnpin(item, event)}
                  title="Unpin message"
                  aria-label="Unpin message"
                >
                  ✕
                </button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default PinnedMessagesBar;
